// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/views/Design/components/Method/styles.scss
// module id = 1273
// module chunks = 0